'use client';

import { truncateString } from '@/utils/functions/stringFormat';
import { ColumnDef } from '@tanstack/react-table';
import type { ReactNode } from 'react';

export type Translate = {
  key: string;
  translate_pt_br: string;
  translate_en_us: string;
  actions: ReactNode;
};

export const translatePanelColumns: ColumnDef<Translate>[] = [
  {
    accessorKey: 'key',
    header: 'Chave',
    size: 250,
    cell: function KeyCell({ row }: { row: { original: Translate } }) {
      return <div className="whitespace-normal break-words w-[250px]">{row.original.key}</div>;
    },
  },
  {
    accessorKey: 'translate_pt_br',
    header: 'pt-BR',
    size: 300,
    cell: function TranslatePtBrCell({ row }: { row: { original: Translate } }) {
      return (
        <div className="whitespace-normal break-words w-[480px]">
          {truncateString(row.original.translate_pt_br, 64)}
        </div>
      );
    },
  },
  {
    accessorKey: 'translate_en_us',
    header: 'en-US',
    size: 300,
    cell: function TranslateEnUsCell({ row }: { row: { original: Translate } }) {
      return (
        <div className="whitespace-normal break-words w-[480px]">
          {truncateString(row.original.translate_en_us, 64)}
        </div>
      );
    },
  },

  {
    accessorKey: 'actions',
    header: '',
    size: 60,
    cell: function ActionsCell({ row }: { row: { original: Translate } }) {
      return <div className="w-full flex justify-end">{row.original.actions}</div>;
    },
  },
];
